import { render, staticRenderFns } from "./YouTubeEmbedLite.vue?vue&type=template&id=0dc25e0b&scoped=true&"
import script from "./YouTubeEmbedLite.vue?vue&type=script&lang=ts&"
export * from "./YouTubeEmbedLite.vue?vue&type=script&lang=ts&"
import style0 from "./YouTubeEmbedLite.vue?vue&type=style&index=0&id=0dc25e0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc25e0b",
  null
  
)

export default component.exports